export default class Contact {

    constructor() {
        if (document.querySelector('#show.contact') !== null) {
            this.map();
        }
    }

    map() {
        if (document.querySelector('#map')) {
            const mapHolder = document.querySelector('#map');

            const map = new google.maps.Map(mapHolder, {
                disableDefaultUI: true,
                center: { lat: 52.6619793, lng: 5.0911084},
                zoom: 13,
            });


            const icon = new google.maps.MarkerImage(
                '/img/map-marker.svg',
                null, /* size is determined at runtime */
                null, /* origin is 0,0 */
                null, /* anchor is bottom center of the scaled image */
                new google.maps.Size(40, 40)
            );

            new google.maps.Marker({
                position: new google.maps.LatLng(52.6619793, 5.0911084),
                map: map,
                icon: icon
            });
        }
    }
}
